import { ExclamationCircleFilled } from "@ant-design/icons";
import { Modal } from "antd";
import * as React from "react";
import { onError } from "src/common/onError";

import { msgQueueStore } from "../MsgQueue";
import * as styles from "./DeleteConfirm.module.less";

type PropsDeleteConfirm = {
  content: React.ReactNode;
  open: boolean;
  close: () => void;
  task: () => Promise<void>;
  successMsg?: string;
  title?: string;
  okText?: string;
  cancelText?: string;
};

export const DeleteConfirm: React.FC<PropsDeleteConfirm> = (props) => {
  const {
    content,
    open,
    close,
    task,
    successMsg = "Удаление выполнено",
    title = "Внимание!",
    okText = "Удалить",
    cancelText = "Отмена",
  } = props;
  const [wait, setWait] = React.useState(false);
  const exec = async () => {
    setWait(true);
    try {
      await task();
      close();
      msgQueueStore.add({ type: "success", message: successMsg });
    } finally {
      setWait(false);
    }
  };
  return (
    <Modal
      title={
        <div className={styles.title}>
          <ExclamationCircleFilled />
          {title}
        </div>
      }
      open={open}
      onCancel={close}
      okButtonProps={{ danger: true, loading: wait }}
      okText={okText}
      cancelText={cancelText}
      onOk={() => exec().catch(onError)}
    >
      {content}
    </Modal>
  );
};
